function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H72V70H0z",
  transform: "translate(0 -4)"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#1ED46A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 28L30.5 38.5 69 0",
  transform: "translate(0 -4) translate(1.5 5.5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63 31.5V56a7 7 0 01-7 7H7a7 7 0 01-7-7V7a7 7 0 017-7h38.5",
  transform: "translate(0 -4) translate(1.5 5.5)"
})));

var SvgIcoSuccess = function SvgIcoSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 66,
    viewBox: "0 0 72 66",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-success.5b8c6003.svg";
export { ForwardRef as ReactComponent };